<template>
  <div class="submit-container">
    <div class="search-form">
      <tag-check-box label="奖项类别" :options="PRIZE_CATEGORY_EMNU" v-model="searchParams.prizeCategoryValue" />
      <tag-check-box label="奖项状态" :options="PRIZE_STATUS_EMNU" v-model="searchParams.prizeStatusValue" />
    </div>

    <div class="table">
      <a-row class="search" type="flex" justify="start">
        <a-col :span="8">
          <a-input-group compact>
            <a-select v-model="searchParams.searchType" style="display: inline-block; width: 160px">
              <a-select-option value="PROJECT_NAME"> 项目名称 </a-select-option>
            </a-select>
            <a-input style="width: calc(100% - 160px)" placeholder="请输入" />
          </a-input-group>
        </a-col>
        <a-button type="primary" style="margin-left: 8px">搜索</a-button>
      </a-row>
      <div class="tips">
        <a-alert banner>
          <div slot="message" class="message">
            1、项目报备编辑分为项目信息、中期检查、绩效评价三个不同节点的信息录入，后台配置有这个节点才可操作，请注意提交截止时间提示，及时提交；
            <br />
            2、已提交的当前无法修改，如需修改/删除请进行申请退回操作； <br />
            3、已下架的如无问题，请及时联系平台申述重新发布，避免影响后期业务对接。
          </div>
        </a-alert>
      </div>
      <div class="actions">
        <a-button type="primary" @click="openReport">
          <a-icon type="plus" />
          新增项目立项
        </a-button>
      </div>
      <div class="data">
        <list-table :list="list" >
          <div slot="data1" slot-scope="{ row }" :span="12">
            <span>项目编号:</span>
            <span>{{ row.data1 }}</span>
          </div>
          <div slot="data2" slot-scope="{ row }" :span="12">
            <span>项目领域:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data3" slot-scope="{ row }" :span="12">
            <span>项目联系人:</span>
            <span>{{ row.data2 }}</span>
          </div>
          <div slot="data4" slot-scope="{ row }" :span="12">
            <span>项目负责人:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data5" slot-scope="{ row }" :span="12">
            <span>发布单位:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data6" slot-scope="{ row }" :span="12">
            <span>新建时间:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data7" slot-scope="{ row }" :span="12">
            <span>提交时间:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data8" slot-scope="{ row }" :span="12">
            <span>申请退回时间:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="data9" slot-scope="{ row }" :span="12">
            <span>退回时间:</span>
            <span>{{ row.data2 }}</span>
          </div>

          <div slot="actions" slot-scope="{ row }">
            <a-dropdown>
              <a-button>更多操作</a-button>
              <a-menu slot="overlay">
                <a-menu-item @click="SendBack">申请退回</a-menu-item>
                <a-menu-item @click="Delete">删除</a-menu-item>
                <a-menu-item @click="preview(row)">预览</a-menu-item>
              </a-menu>
            </a-dropdown>

            <a-divider type="vertical" />
            <a-button type="primary" @click="openCompile">编辑</a-button>
            <a-divider type="vertical" />
            <a-button type="primary" @click="submit">提交</a-button>
          </div>
          <div slot="footer" slot-scope="{ row }" :span="12">
            <a-tag v-for="index in 30" :key="index" style="margin-bottom: 9px">Tag 1</a-tag>
          </div>
        </list-table>
      </div>
    </div>
    <!-- 添加/详情弹框 -->
    <j-modal
      title="项目报备编辑/新增"
      :visible="reportVisible"
      switchFullscreen
      :fullscreen="true"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="关闭"
    >
      <report-modal-list></report-modal-list>
    </j-modal>
  </div>
</template>

<script>
import TagCheckBox from '../../../components/TagCheckBox'
import ListTable from '../../../components/ListTable'
import ReportModalList from './reportModalList.vue'
const PRIZE_STATUS_EMNU = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '项目信息待提交',
    value: '项目信息待提交',
  },
  {
    label: '项目信息待审核',
    value: '项目信息待审核',
  },
  {
    label: '项目信息审核驳回',
    value: '项目信息审核驳回',
  },
  {
    label: '中期检查待提交',
    value: '中期检查待提交',
  },
  {
    label: '中期检查待审核',
    value: '中期检查待审核',
  },
  {
    label: '中期检查审核驳回',
    value: '中期检查审核驳回',
  },
  {
    label: '绩效评价待提交',
    value: '绩效评价待提交',
  },
  {
    label: '绩效评价待审核',
    value: '绩效评价待审核',
  },
  {
    label: '绩效评价审核驳回',
    value: '绩效评价审核驳回',
  },
  {
    label: '验收完成',
    value: '验收完成',
  },
  {
    label: '已发布',
    value: '已发布',
  },
  {
    label: '已下架',
    value: '已下架',
  },
  {
    label: '待退回',
    value: '待退回',
  },
  {
    label: '已退回',
    value: '已退回',
  },
]
const PRIZE_CATEGORY_EMNU = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '基础研究',
    value: '基础研究',
  },
  {
    label: '重点研发',
    value: '重点研发',
  },
  {
    label: '消防管理理论与软科学',
    value: '消防管理理论与软科学',
  },
  {
    label: '应用创新',
    value: '应用创新',
  },
  {
    label: '其他',
    value: '其他',
  },
]
export default {
  components: {
    TagCheckBox,
    ListTable,
    ReportModalList,
  },
  data() {
    return {
      reportVisible: false,
      
      list: [
        {
          id: '1',
          title: 'xxxxxxx',
          status: '',
          data1: '',
          data2: '',
          data3: '',
          data4: '',
          data5: '',
          data6: '',
          data7: '',
          data8: '',
          data9: '',
        },
      ],
      searchParams: {
        prizeStatusValue: [''],
        prizeCategoryValue: [''],
        searchType: 'PROJECT_NAME',
      },
      PRIZE_STATUS_EMNU,
      PRIZE_CATEGORY_EMNU,
    }
  },
  methods: {
    //新增项目
    openReport() {
      this.reportVisible = true
    },
    //添加/详情弹框确定按钮
    handleOk() {
      this.reportVisible = false
    },
    //添加/详情弹框取消按钮
    handleCancel() {
      this.reportVisible = false
    },
    //编辑
    openCompile() {
      this.reportVisible = true
    },
    
    //提交
    submit() {
      this.$confirm({
        title: '提交',
        icon:'exclamation-circle',
        content: (
          <div>
            <p>确定提交？</p>
            <p>提交后无法编辑与删除，需申请退回才可进行修改。</p>
          </div>
        ),
        okText: '确认',
        cancelText: '取消',
        onOk() {
          console.log('确定提交')
        },
      })
    },
    //申请退回
    SendBack() {
      this.$confirm({
        title: '申请退回',
        icon:'exclamation-circle',
        content: (
          <div>
            <p>确定申请退回？</p>
            <p>发送申请后需审核人员操作退回才能进行编辑/删除。</p>
          </div>
        ),
        okText: '确认',
        cancelText: '取消',
        onOk() {
          console.log('申请退回')
        },
      })
    },
    //删除项目
    Delete() {
      this.$confirm({
        title: '删除',
        icon:'exclamation-circle',
        content: '删除后将无法列表中查询到此条信息，请谨慎操作。',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          console.log('确定删除')
        },
      })
    },
    //预览
    preview(row){
      this.$router.push(`/project/achievements/preview/${row.id}`)
    }
  },
}
</script>

<style lang="less" scoped>
.submit-container {
  background: #f0f2f5;
  .search-form {
    padding: 0 20px 20px;
    background: #fff;
  }
  .table {
    margin-top: 16px;
    background: #fff;
  }
  .search {
    padding: 24px 16px;
    border-bottom: 1px #f0f0f0 solid;
  }
  .tips {
    margin: 14px 15px;
    .message {
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
      font-weight: 400;
      line-height: 1.6;
      margin-left: 10px;
    }
  }
  .actions {
    margin: 14px 15px 0;
  }
  .data {
    padding: 0 14px 15px;
  }
}
</style>